import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { PlayerSupportLookup } from '../../api/models';

export type TABLE_TYPE = Table<PlayerSupportLookup>;

export const TABLE = 'playerSupportLookup';
const SCHEMA = 'playerSupportLookupId, sortId';

class PlayerSupportLookupDatabase implements DataRepository<PlayerSupportLookup> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<PlayerSupportLookup | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: PlayerSupportLookup, key: Key): Promise<PlayerSupportLookup> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: PlayerSupportLookup[]): Promise<PlayerSupportLookup[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<PlayerSupportLookup[]> {
    return this.db[TABLE].toArray();
  }
}

export const PlayerSupportLookupDB = new PlayerSupportLookupDatabase(db);
